import styled, { keyframes } from 'styled-components';

import colors from 'styles/colors';

export const AttachmentsStyled = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  h3 {
    margin-bottom: 16px;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
    color: #3e3e3e;
  }
`;

export const AttachmentsHeaderStyled = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  column-gap: 24px;
  min-width: 0;
  width: 100%;
`;

export const AttachmentsActionsStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  column-gap: 24px;
`;

export const AttachmentsListStyled = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const AttachmentItemStyled = styled.li`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  column-gap: 8px;
  padding: 8px;
  width: 100%;
  min-width: 0;
  border-radius: 4px;
  border: 1px solid #e5e5e5;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
  
  @media (hover: hover) {
    &:hover {
      background: #f5f5f5;
    }
  }
`;

export const AttachmentNameStyled = styled.span`
  display: flex;
  flex: 1;
  font-size: 16px;
  line-height: 1.5;
  color: #3e3e3e;
  word-break: break-word;
`;

export const AttachmentItemActionsStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  column-gap: 24px;
`;

export const AttachmentTypeStyled = styled.figure`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 8px;
  border-radius: 4px;
  width: 40px;
  height: 40px;
  background: #e5e5e5;
`;

const progressPulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
`;

export const UploadProgressItemStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 6px;
  padding: 10px 12px;
  width: 100%;
  border-radius: 4px;
  border: 1px dashed ${colors.brand_1};
  background: ${colors.brand_2_tint_10};
  animation: ${progressPulse} 1.6s ease-in-out infinite;
`;

export const ProgressLabel = styled.span`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: ${colors.brand_2};
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: 6px;
  background: ${colors.gray_scale4};
  border-radius: 3px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ value: number }>`
  height: 100%;
  width: ${({ value }) => value}%;
  background: ${colors.brand_1};
  border-radius: 3px;
  transition: width 0.15s ease;
`;

export const ProgressCancelButton = styled.button`
  align-self: flex-end;
  margin-top: 4px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  color: ${colors.brand_2};
  text-decoration: underline;
  line-height: 1.4;

  &:hover {
    color: ${colors.error};
    opacity: 0.85;
  }
`;

